import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Flex, FlexSpan } from "../../../ui";
import { StarRating } from "../../../components/StarRating";
export const AreaRating = ({ rating }) => {
    if (rating === undefined) {
        return null;
    }
    return (_jsxs(Flex, { gap: "0.5rem", alignItems: "end", children: [_jsx(FlexSpan, { display: "flex", children: _jsx(StarRating, { rating: rating }) }), _jsx(FlexSpan, { display: "flex", children: _jsx(Badge, { backgroundColor: "#ECECEC", small: true, children: _jsx(FlexSpan, { fontSize: "0.75rem", fontWeight: 600, lineHeight: "100%", children: rating }) }) })] }));
};
